export class TileHouse {
  аrea: number;
  areaAsText: string;
  tileName: string;
  imgSmall: string;
  imgLarge: string;
  photosNames: string[];
}
